import { get } from '../api';

export async function loadAppData() {
    const [user, settings] = await Promise.all([
        get('/api/user'),
        get('/api/settings'),
    ]);
    return {
        user: user.data,
        settings,
    };
}

export function accessEnvironment(config, environment) {
    if (config && environment) {
        if (config.exclude) {
            return !config.exclude.includes(environment);
        }
        if (config.include) {
            return config.include.includes(environment);
        }
    }
    return true;
}

export function getNestedValue(object, path) {
    return path.split('.').reduce((o, i) => o[i], object);
}

export function setNestedValue(obj, path, value) {
    const pList = path.split('.');
    const key = pList.pop();
    const pointer = pList.reduce((accumulator, currentValue) => {
        if (accumulator[currentValue] === undefined)
            accumulator[currentValue] = {};
        return accumulator[currentValue];
    }, obj);
    pointer[key] = value;
    return obj;
}

export function defaultObjectSort(array, path) {
    return array.sort((a, b) => {
        a = getNestedValue(a, path);
        b = getNestedValue(b, path);
        if (a.toLowerCase() < b.toLowerCase()) return -1;
        if (a.toLowerCase() > b.toLowerCase()) return 1;
        return 0;
    });
}

export function reverseObject(object) {
    const newObject = {};
    Object.keys(object).forEach(item => {
        newObject[object[item]] = item;
    });
    return newObject;
}
